import * as LabelPrimitive from '@radix-ui/react-label';
import * as React from 'react';
import { tv, type VariantProps } from 'tailwind-variants';

const labelVariants = tv({
  base: 'leading-none select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50',
  variants: {
    variant: {
      default:  'text-sm font-medium text-foreground',
      muted:    'text-sm font-normal text-muted-foreground',
      required: 'text-sm font-medium text-foreground after:content-["*"] after:ml-0.5 after:text-destructive',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

function Label({
  className,
  variant,
  ...props
}: React.ComponentProps<typeof LabelPrimitive.Root> & VariantProps<typeof labelVariants>) {
  return (
    <LabelPrimitive.Root
      data-slot="label"
      className={labelVariants({ variant, class: className })}
      {...props}
    />
  );
}

export { Label, labelVariants };
